<template>
  <div>
    <vx-card
      :title="$t('labels.edit_profile')"
      v-if="$store.state.userInfo.type === 'A' || $store.state.userInfo.type === 'CL'"
    >
      <div>
        <basic-details></basic-details>
      </div>
    </vx-card>
    <div v-if="$store.state.userInfo.type === 'CN'">
      <consultant-details></consultant-details>
    </div>
  </div>
</template>

<script>
import ConsultantDetails from "@/layouts/components/consultant-detail/consultantDetails.vue";
import BasicDetails from "@/layouts/components/consultant-detail/basicDetails.vue";
export default {
  components: {
    ConsultantDetails,
    BasicDetails
  }
};
</script>
